/**
 * Normalize a company/external website URL for href use.
 *
 * Bare hosts like `www.therassist.ai` are relative to the current origin in the
 * browser, which produces `https://www.prairi.com/www.therassist.ai`. Strip any
 * accidental prairi.com prefix and ensure an absolute http(s) URL.
 */
export function normalizeExternalUrl(raw: string | null | undefined): string {
  if (!raw) return '';
  let url = raw.trim();
  if (!url) return '';

  // May be nested if a bad relative URL was later stored with the host prepended.
  for (let i = 0; i < 5; i++) {
    const next = url
      .replace(/^(?:https?:)?\/\/(?:www\.)?prairi\.com\/?/i, '')
      .replace(/^(?:www\.)?prairi\.com\/?/i, '');
    if (next === url) break;
    url = next.trim();
  }

  if (!url) return '';

  if (url.startsWith('//')) {
    return `https:${url}`;
  }

  // Already has a scheme (http:, https:, mailto:, etc.)
  if (/^[a-z][a-z0-9+.-]*:/i.test(url)) {
    return url;
  }

  return `https://${url.replace(/^\/+/, '')}`;
}
